<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        <el-tag
          v-if="state.model.status === 0"
          effect="dark"
          size="small"
          type="danger"
          title="停用"
          style="cursor: pointer; margin-right: 5px"
        >
          停
        </el-tag>
        <li
          style="
            font-size: 13px;
            font-weight: 600;
            flex: 1;
            display: flex;
            align-items: center;
          "
        >
          {{ state.model.name }}
          <text
            style="color: #1e90ff"
            class="text-hover-decoration"
            title="统一社会信用代码"
            @click="$onCopy(state.model.unified_social_credit_identifier)"
          >
            ({{ state.model.unified_social_credit_identifier }})
          </text>
          <div
            style="
              margin-left: 10px;
              display: flex;
              color: #f00;
              cursor: pointer;
              align-items: center;
            "
            title="服务费"
          >
            <template v-if="state.model.service_cost_calc_rate > 0">
              <text
                v-if="
                  state.model.service_cost_calc_mode == 1 ||
                  state.model.service_cost_calc_mode == 2
                "
              >
                {{
                  state.model.service_cost_calc_mode == 1
                    ? "应发工资的"
                    : "应发工资-代扣项目"
                }}
              </text>
              {{ state.model.service_cost_calc_rate + "%" }}
            </template>
            <template
              v-if="
                state.model.service_cost_calc_rate > 0 &&
                state.model.service_cost > 0
              "
            >
              +
            </template>
            <template v-if="state.model.service_cost > 0">
              <text
                v-if="
                  state.model.service_cost_type == 1 ||
                  state.model.service_cost_type == 2
                "
              >
                {{
                  state.model.service_cost_type == 1 ? "每人每月" : "每人每笔"
                }}
              </text>
              {{ state.model.service_cost + "元" }}
            </template>
          </div>
          <el-popover width="60%" trigger="hover">
            <template #reference>
              <el-icon
                size="16"
                color="#1E90FF"
                style="margin-left: 10px; cursor: pointer"
              >
                <View />
              </el-icon>
            </template>
            <template #default>
              <div style="font-weight: 600; font-size: 13px">基本信息</div>
              <el-descriptions
                :column="3"
                border
                style="margin: 10px"
                class="desc-label-nowrap"
              >
                <el-descriptions-item label="名称" label-align="right">
                  <div style="min-width: 200px">
                    {{ state.model.name }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="状态" label-align="right">
                  <div
                    style="min-width: 200px"
                    :style="{
                      color: state.model.status == 1 ? '#1e90ff' : '#f00',
                    }"
                  >
                    {{ state.model.status == 1 ? "正常" : "停用" }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item
                  label="统一社会信用代码"
                  label-align="right"
                >
                  <div style="min-width: 200px">
                    {{ state.model.unified_social_credit_identifier }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="所属行业" label-align="right">
                  <div style="min-width: 200px">
                    {{ state.model.d_customer_type_name }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="所属地区" label-align="right">
                  <div style="min-width: 200px">
                    {{
                      state.model.province +
                      (state.model.city || "") +
                      (state.model.district || "")
                    }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="详细地址" label-align="right">
                  <div style="min-width: 200px">
                    {{ state.model.address }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="对接人姓名" label-align="right">
                  <div style="min-width: 200px">
                    {{ state.model.contact_name }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="职务" label-align="right">
                  <div style="min-width: 200px">
                    {{ state.model.contact_job }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="联系方式" label-align="right">
                  <div style="min-width: 200px">
                    {{ state.model.contact_name }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="个税承担类型" label-align="right">
                  <div style="min-width: 200px">
                    {{ state.model.tax_mode == 0 ? "个人" : "公司" }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="签单时间" label-align="right">
                  <div style="min-width: 200px">
                    {{ state.model.contract_time }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="负责人" label-align="right">
                  <div style="min-width: 200px; display: flex">
                    {{ state.model.belonger_name }}
                    <text v-if="state.model.belonger_department_name">
                      {{ "/" + state.model.belonger_department_name }}
                    </text>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="服务类型" label-align="right">
                  <div style="min-width: 200px; display: flex">
                    {{ state.model.d_service_name }}
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="服务费" label-align="right">
                  <div style="min-width: 200px; display: flex">
                    <template v-if="state.model.service_cost_calc_rate > 0">
                      <text
                        v-if="
                          state.model.service_cost_calc_mode == 1 ||
                          state.model.service_cost_calc_mode == 2
                        "
                      >
                        {{
                          state.model.service_cost_calc_mode == 1
                            ? "应发工资的"
                            : "应发工资-代扣项目的"
                        }}
                      </text>
                      {{ state.model.service_cost_calc_rate + "%" }}
                    </template>
                    <template
                      v-if="
                        state.model.service_cost_calc_rate > 0 &&
                        state.model.service_cost > 0
                      "
                    >
                      +
                    </template>
                    <template v-if="state.model.service_cost > 0">
                      <text
                        v-if="
                          state.model.service_cost_type == 1 ||
                          state.model.service_cost_type == 2
                        "
                      >
                        {{
                          state.model.service_cost_type == 1
                            ? "每人每月"
                            : "每人每笔"
                        }}
                      </text>
                      {{ state.model.service_cost + "元" }}
                    </template>
                  </div>
                </el-descriptions-item>
              </el-descriptions>
            </template>
          </el-popover>
        </li>
        <li style="display: flex; align-items: center">
          <el-button
            type="primary"
            link
            icon="Edit"
            @click="state.showEdit = true"
            v-if="$judge_auth('47')"
            >编辑信息</el-button
          >
        </li>
      </ul>
      <div class="customer-detail-statistics">
        <li>
          <c_statistics
            :value="state.statistics?.settle_amount"
            value-style="color: #ffa500"
          />
          <text>结算金额</text>
        </li>
        <li>
          <c_statistics
            :value="state.statistics?.receipt_amount"
            value-style="color: #ffa500"
          />
          <text>已收款</text>
        </li>
        <li>
          <c_statistics
            :value="state.statistics?.arrearage_amount"
            value-style="color: #ffa500"
          />
          <text>欠款</text>
        </li>
        <li>
          <c_statistics
            :value="state.statistics?.pay_amount"
            value-style="color: #ffa500"
          />
          <text>发薪总额</text>
        </li>
        <li>
          <c_statistics
            :value="state.statistics?.paied_amount"
            value-style="color: #ffa500"
          />
          <text>已发放</text>
        </li>
        <li>
          <c_statistics
            :value="state.statistics?.unpaied_amount"
            color="#f00"
            :duration="1000"
            bold
          />
          <text style="color: #f00; font-weight: 600">未发放</text>
        </li>
        <li>
          <c_statistics
            :value="state.statistics?.invoiced_amount"
            value-style="color: #ffa500"
          />
          <text>已开票金额</text>
        </li>
        <el-popover
          placement="bottom-end"
          trigger="hover"
          popper-style="width: auto"
        >
          <template #reference>
            <el-button type="primary" link icon="Memo">其他费用</el-button>
          </template>
          <template #default>
            <div style="font-weight: 600; font-size: 13px">其他费用</div>
            <el-descriptions
              :column="4"
              border
              style="overflow-x: auto; margin-top: 10px"
              class="desc-label-nowrap"
            >
              <el-descriptions-item
                :label="item"
                label-align="right"
                v-for="item in state.statisticsKeys"
                :key="item"
              >
                <c_money
                  :value="state.statistics.invoiced_data[item]"
                  :size="16"
                  style="color: #ffa500"
                ></c_money>
              </el-descriptions-item>
            </el-descriptions>
          </template>
        </el-popover>
      </div>
      <ul
        style="
          flex: 1;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        "
      >
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
          "
        >
          <el-tab-pane label="工资表模板" name="SalaryTemplate">
            <c_SalaryTemplate
              :customer_id="props.data?.id"
              :customer_name="state.model?.name"
              v-if="state.model.id && state.activeName == 'SalaryTemplate'"
            ></c_SalaryTemplate>
          </el-tab-pane>
          <el-tab-pane label="子账户" name="Subaccount">
            <c_Subaccount
              :customer_id="props.data?.id"
              v-if="state.activeName == 'Subaccount'"
            ></c_Subaccount>
          </el-tab-pane>
          <el-tab-pane label="工资表" name="Payroll">
            <c_Payroll
              :customer_id="props.data?.id"
              v-if="state.activeName == 'Payroll'"
            ></c_Payroll>
          </el-tab-pane>
          <el-tab-pane label="算税申请" name="CalcTax">
            <c_CalcTax
              :customer_id="props.data?.id"
              v-if="state.activeName == 'CalcTax'"
            ></c_CalcTax>
          </el-tab-pane>
          <el-tab-pane label="发薪申请" name="SalaryRecord">
            <c_SalaryRecord
              :customer_id="props.data?.id"
              v-if="state.activeName == 'SalaryRecord'"
            ></c_SalaryRecord>
          </el-tab-pane>
          <el-tab-pane label="员工花名册" name="Employee">
            <c_Employee
              :customer_id="props.data?.id"
              v-if="state.activeName == 'Employee'"
            ></c_Employee>
          </el-tab-pane>
          <el-tab-pane label="客户到款" name="BankReceived">
            <c_BankReceived
              :customer_id="props.data?.id"
              v-if="state.activeName == 'BankReceived'"
            ></c_BankReceived>
          </el-tab-pane>
          <el-tab-pane label="开票记录" name="Invoice">
            <c_Invoice
              :customer_id="props.data?.id"
              :customer_code="state.model.unified_social_credit_identifier"
              v-if="
                state.activeName == 'Invoice' &&
                state.model.unified_social_credit_identifier
              "
            ></c_Invoice>
          </el-tab-pane>
        </el-tabs>
      </ul>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑员工"
      @close="state.showEdit = false"
    >
      <c_CustomerInfo
        @close="
          state.showEdit = false;
          onLoad();
        "
        :id="props.data?.id"
      ></c_CustomerInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  customermine_detail,
  customermine_payroll_list,
} from "@/http/customer";

import c_SalaryTemplate from "./Detail/SalaryTemplate/Index.vue";
import c_Subaccount from "./Detail/Subaccount/List.vue";
import c_Payroll from "./Detail/Payroll/List.vue";
import c_CalcTax from "./Detail/CalcTax/List.vue";
import c_SalaryRecord from "./Detail/SalaryRecord/List.vue";
import c_Employee from "./Detail/Employee/List.vue";
import c_BankReceived from "./Detail/BankReceived/List.vue";
import c_Invoice from "./Detail/Invoice/List.vue";

export default {
  components: {
    c_SalaryTemplate,
    c_Subaccount,
    c_Payroll,
    c_CalcTax,
    c_SalaryRecord,
    c_Employee,
    c_BankReceived,
    c_Invoice,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      model: {},
      activeName: "SalaryTemplate",
    });

    onMounted(() => {
      customermine_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });

      customermine_payroll_list({ customer_id: props.data?.id }).then((res) => {
        if (res.status == 200) {
          const { statistics } = res.data.data;
          state.statistics = statistics;
          state.statisticsKeys = Object.keys(statistics.invoiced_data);
        }
      });
    });

    return { state, props };
  },
};
</script>
<style scoped lang="less">
.cus-desc {
  & > div {
    width: 25%;
  }
}

.customer-detail-statistics {
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 20px 40px;
  margin: 20px;
  width: calc(100% - 40px);
  background-color: #f6f6f6;

  & > li {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    & > div {
      color: #ffa500;
    }

    & > text {
      color: #a2a2a2;
      margin-top: 10px;
      font-size: 12px;
      margin-left: 10px;
    }
  }
}
</style>
